import styled from "styled-components";

const SpinnerContainer = styled.div`
  display: inline-block;
`;
export default SpinnerContainer;
